import StepFour from 'views/register/stepFour/StepFour.container';

export default StepFour;